import { render, staticRenderFns } from "./SettingOrderInstall.vue?vue&type=template&id=04ca08e3&"
import script from "./SettingOrderInstall.vue?vue&type=script&lang=ts&"
export * from "./SettingOrderInstall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports